import { media } from 'responsive/media';
import styled, { css } from 'styled-components';

export const StyledSelect = styled.select`
  max-width: ${(props) => (props.$width ? `${props.$width}px` : '339px')};
  height: ${(props) => (props.$height ? `${props.$height}px` : '40px')};
  border-radius: ${(props) => (props.rounded ? `${props.rounded}px` : '10px')};
  padding: 10px;
  font-size: 14px;
  font-family: 'Roboto', sans-serif;
  outline: none;
  transition: all 0.3s ease;
  background-color: #ffffff;
  color: #333333;

  &:focus {
    border-color: #ed7836;
    box-shadow: 0 0 0 2px rgba(237, 120, 54, 0.1);
  }

  &:hover {
    border-color: #ed7836;
  }

  &.error {
    border-color: #ff4d4f;
    box-shadow: 0 0 0 2px rgba(255, 77, 79, 0.1);
  }
`;

export const SelectRow = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  width: max-content;
  height: inherit;
`;

export const SelectLabel = styled.label`
  font-weight: 400;
  min-width: ${(prop) =>
    prop.$isPopup
      ? `${prop.$widthLabelPopup}px` || '136px'
      : `${prop.$widthLabel}px` || '273px'};
  width: max-content;
  text-align: left;
  width: ${(props) => (props.$isWebkit ? '-webkit-fill-available' : 'auto')};
  .required {
    color: red;
    margin-left: 4px;
  }

  ${media.xxlDown(css`
    min-width: ${({ $widthLabel, $isPopup }) =>
      $isPopup
        ? `${$widthLabel}px`
        : $widthLabel
          ? `${$widthLabel * 0.9}px`
          : ''};
  `)}

  ${media.xlDown(css`
    min-width: ${({ $widthLabel, $isPopup }) =>
      $isPopup ? `${$widthLabel}px` : $widthLabel ? `${$widthLabel}px` : ''};
  `)}

  ${media.lgDown(css`
    min-width: auto;
    width: max-content;
    margin-bottom: 4px;
  `)}
`;

export const ErrorMessage = styled.div`
  color: #ff4d4f;
  margin-left: ${(props) =>
    props.$paddingMessage ? `${props.$paddingMessage}px` : '290px'};
  min-height: 0;
  font-size: 12px;
  transition: opacity 0.3s ease;
`;

// Custom dropdown styles
export const DropdownContainer = styled.div.withConfig({
  shouldForwardProp: (prop) =>
    ![
      '$iconDown',
      'iconDown',
      'widthSelect',
      'heightSelect',
      'textColor',
      'sizeIcon',
      'dropdownRender',
      'dropdownMatchSelectWidth',
      'dropdownStyle',
      'popupClassName',
      'suffixIcon',
      'bordered',
      'showArrow',
      'popupMatchSelectWidth',
      'isShowCurrent',
    ].includes(prop),
})`
  position: relative;
  width: ${(props) => (props.$width ? `${props.$width}px` : '100%')};
  max-width: 100%;

  ${media.xlDown(css`
    width: ${(props) =>
      props.$isPopup
        ? '100%'
        : props.$width
          ? `${props.$width * 0.8}px`
          : '100%'};
  `)}

  ${media.xxlDown(css`
    width: ${(props) =>
      props.$isPopup
        ? '100%'
        : props.$width
          ? `${props.$width * 0.6}px`
          : '100%'};
  `)}
`;

export const DropdownControl = styled.div`
  width: ${(props) => (props.$width ? `${props.$width}px` : '100%')};
  height: ${(props) => (props.$height ? `${props.$height}px` : '40px')};
  border-radius: ${(props) => (props.rounded ? `${props.rounded}px` : '10px')};
  border: 1px solid #e9e9e9;
  border: ${(props) =>
    props.$error ? '1px solid #ff4d4f' : '1px solid #e9e9e9'};
  border: ${(props) => (props.$bordered ? '1px solid #e9e9e9' : 'none')};
  padding: 0 12px 0 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  line-height: 22px;
  font-weight: 400;
  font-family: 'Roboto', sans-serif;
  background-color: ${(props) => (props.disabled ? '#f5f5f5' : '')};
  color: ${(props) => (props.disabled ? '#999999' : '')};
  cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
  transition: all 0.3s ease;
  border-radius: 2px !important;

  &:hover {
    border-color: ${(props) =>
      props.disabled ? '#e9e9e9' : props.onTable ? '#f5f5f5' : '#ed7836'};
  }

  &.open {
    border-color: ${(props) => (props.onTable ? '#f5f5f5' : '#ed7836')};
    box-shadow: 0 0 0 2px rgba(237, 120, 54, 0.1);
  }

  &.error {
    border-color: #ff4d4f;
    box-shadow: 0 0 0 2px rgba(255, 77, 79, 0.1);
  }

  /* ========= Responsive ========= */
  ${media.xxlDown(css`
    height: ${({ $height }) => ($height ? `${$height * 0.9}px` : '36px')};
    max-width: ${({ width, $isPopup }) =>
      $isPopup ? '100%' : width ? `${width * 0.9}px` : ''};
  `)}

  ${media.xlDown(css`
    max-width: ${({ $width, $isPopup }) =>
      $isPopup ? '100%' : $width ? `${$width * 0.8}px` : ''};
    height: ${({ $height }) => ($height ? `${$height * 0.8}px` : '32px')};
  `)}

  ${media.lgDown(css``)}
`;

export const ValueText = styled.span`
  line-height: 22px;
  font-weight: 400;
  color: ${(props) => (props.$placeholder ? '#999999' : '')};
  color: ${(props) => (props.disabled ? '#999999' : '')};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const IconWrapper = styled.span`
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  display: inline-flex;
  width: 24px;
  height: 24px;

  img,
  svg {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;

export const DropdownList = styled.ul`
  position: absolute;
  z-index: 1000;
  top: calc(
    ${(props) => (props.controlHeight ? `${props.controlHeight}px` : '39px')} +
      6px
  );
  left: 0;
  right: 0;
  background: #fff;
  border: ${(props) => (props.disabled ? 'transparent' : '#d9d9d9')};
  border-radius: 10px;
  padding: 6px 0;
  margin: 0;
  list-style: none;
  max-height: 260px;
  overflow: auto;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.08);

  ${media.xxlDown(css`
    height: ${({ $height }) => ($height ? `${$height * 0.9}px` : '36px')};
    width: ${({ width }) => (width ? `${width * 0.9}px` : '')};
    font-size: 13px;
  `)}

  ${media.xlDown(css`
    height: ${({ $height }) => ($height ? `${$height * 0.8}px` : '32px')};
    width: ${({ width }) => (width ? `${width * 0.8}px` : '')};
  `)}

  ${media.lgDown(css`
    width: max-content;
  `)}
`;

export const DropdownItem = styled.li.withConfig({
  shouldForwardProp: (prop) => !['pagination'].includes(prop),
})`
  display: flex;
  align-items: center;
  justify-content: start;
  border-radius: 8px;
  padding: ${(props) => (props.pagination ? '7px 6px' : '10px 6px')};
  line-height: 22px;
  font-weight: 400;
  font-size: 14px;
  color: ${(props) => (props.disabled ? '#bfbfbf' : '#333')};
  cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
  background: ${(props) =>
    props.$active ? 'rgba(237, 120, 54, 0.08)' : 'transparent'};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  &:hover {
    background: ${(props) =>
      props.disabled ? 'transparent' : 'rgba(0,0,0,0.04)'};
  }

  &.disabled {
    cursor: default; /* normal cursor for noDataText item */
    color: #999999 !important;
    border: 1px solid #e9e9e9 !important;
    pointer-events: none; /* prevent click */
  }

  &.disabled:hover {
    background: transparent; /* no hover effect */
  }

  ${media.xxlDown(css`
    height: ${({ $height }) => ($height ? `${$height * 0.9}px` : '36px')};
    font-size: 13px !important;
  `)}

  ${media.xlDown(css`
    height: ${({ $height }) => ($height ? `${$height * 0.8}px` : '32px')};
    font-size: 12px !important;
  `)}

  ${media.lgDown(css`
    width: max-content;
  `)}
`;

// Floating list rendered via portal to avoid parent overflow clipping
export const FloatingList = styled.ul`
  position: absolute;
  z-index: 2000;
  top: ${(props) => (props.top !== undefined ? `${props.top}px` : '0')};
  left: ${(props) => (props.left !== undefined ? `${props.left}px` : '0')};
  width: ${(props) =>
    props.width !== undefined ? `${props.width}px` : 'auto'};
  background: #fff;
  border: 1px solid #e9e9e9;
  border-radius: 10px;
  padding: 5px;
  margin: 0;
  list-style: none;
  max-height: ${(props) =>
    props.$maxHeight !== undefined ? `${props.$maxHeight}px` : '260px'};
  overflow: auto;
  box-shadow: 0 0 8px rgba(0, 0, 0, 0.08);
`;
